import { motion } from "framer-motion";
// import { FiFilter } from "react-icons/fi";
// import { useState, useEffect } from "react";
import projects from "../../Data/Projects.js";
import ProjectsCard from "../../Components/UIVerse/ProjectsCard";
import FeedbackCard from "../../Components/UIVerse/FeedbackCard";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const WorkPage = () => {

  const handleScroll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // const categories = ["all", "web", "mobile", "Marketing"];
  // const [activeCategory, setActiveCategory] = useState("all");
  // const [filteredProjects, setFilteredProjects] = useState(projects);

  // useEffect(() => {
  //   if (activeCategory === "all") {
  //     setFilteredProjects(projects);
  //   } else {
  //     setFilteredProjects(projects.filter(project => project.category === activeCategory));
  //   }
  // }, [activeCategory]);

  return (
    <div className="bg-gradient-to-br from-gray-900 to-blue-900">
      <Helmet>
        <title>Our Work | Mern Digital</title>
        <meta name="description" content="Explore our portfolio of innovative projects and client success stories at Mern Digital." />
        <link rel="canonical" href="https://merndigital.com/work" />
      </Helmet>
      {/* Hero Section */}
      <section className="relative overflow-hidden text-white">
        {/* Animated background elements */}
        <motion.div
          animate={{
            x: [0, 100, 0],
            rotate: [0, 180],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "linear",
          }}
          className="absolute top-1/4 -left-40 w-80 h-80 bg-blue-700/20 rounded-full blur-xl"
        />

        <motion.div
          animate={{
            y: [0, 40, 0],
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          }}
          className="absolute bottom-1/3 right-20 w-64 h-64 bg-purple-700/20 rounded-full blur-xl"
        />

        <div className="container mx-auto px-6 py-32 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                Our Work
              </span>
            </h1>
            <p className="text-xl text-blue-100 mb-2">
              Explore our portfolio of innovative projects and client success stories
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filter Controls (commented out for now) */}
      {/* <section className="py-12 top-10 z-10 shadow-sm">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-4"
          >
            {categories.map((category) => (
              <motion.button
                key={category}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-3 rounded-full font-medium flex items-center ${
                  activeCategory === category
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                }`}
              >
                {activeCategory === category && <FiFilter className="mr-2" />}
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </motion.button>
            ))}
          </motion.div>
        </div>
      </section> */}

      {/* Projects Grid */}
      <section className="py-2">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-10"
          >
            {projects.map((project) => (
              <Link to={`/work/${project.slug}`} key={project.id}>
                <ProjectsCard key={project.id} project={project} />
              </Link>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12">
        <FeedbackCard />
      </section>

      {/* CTA */}
      <section className="py-28 text-white">
        <div className="container mx-auto p-6 text-center border border-white rounded-2xl">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to start your project?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Let's create something amazing together.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link onClick={handleScroll} to="/quotation">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-white text-blue-600 px-8 py-4 rounded-full font-bold shadow-lg"
                >
                  Get A Quote
                </motion.button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default WorkPage;
